module.exports = __webpack_public_path__ + "img/calendar.ffeb9ffa.png";